"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

!function (t, e) {
  for (var r in e) {
    t[r] = e[r];
  }
}(exports, function (t) {
  var e = {};function r(n) {
    if (e[n]) return e[n].exports;var i = e[n] = { i: n, l: !1, exports: {} };return t[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
  }return r.m = t, r.c = e, r.d = function (t, e, n) {
    r.o(t, e) || Object.defineProperty(t, e, { enumerable: !0, get: n });
  }, r.r = function (t) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(t, "__esModule", { value: !0 });
  }, r.t = function (t, e) {
    if (1 & e && (t = r(t)), 8 & e) return t;if (4 & e && "object" == (typeof t === "undefined" ? "undefined" : _typeof(t)) && t && t.__esModule) return t;var n = Object.create(null);if (r.r(n), Object.defineProperty(n, "default", { enumerable: !0, value: t }), 2 & e && "string" != typeof t) for (var i in t) {
      r.d(n, i, function (e) {
        return t[e];
      }.bind(null, i));
    }return n;
  }, r.n = function (t) {
    var e = t && t.__esModule ? function () {
      return t.default;
    } : function () {
      return t;
    };return r.d(e, "a", e), e;
  }, r.o = function (t, e) {
    return Object.prototype.hasOwnProperty.call(t, e);
  }, r.p = "", r(r.s = 102);
}({ 0: function _(t, e) {
    t.exports = function () {
      function _class() {
        _classCallCheck(this, _class);
      }

      _createClass(_class, null, [{
        key: "triggerEvent",
        value: function triggerEvent(t, e) {
          var r = void 0;"function" == typeof Event ? r = new Event(e) : (r = document.createEvent("Event"), r.initEvent(e, !0, !0)), t.dispatchEvent(r);
        }
      }, {
        key: "getElementByAttribute",
        value: function getElementByAttribute(t, e) {
          return e ? document.querySelector("[" + t + "=\"" + e + "\"]") : document.querySelector("[" + t + "]");
        }
      }, {
        key: "getElementsByAttribute",
        value: function getElementsByAttribute(t, e) {
          return e ? document.querySelectorAll("[" + t + "=\"" + e + "\"]") : document.querySelectorAll("[" + t + "]");
        }
      }, {
        key: "getElementByAttributeWithinElement",
        value: function getElementByAttributeWithinElement(t, e, r) {
          return r ? t.querySelector("[" + e + "=\"" + r + "\"]") : t.querySelector("[" + e + "]");
        }
      }, {
        key: "isMouseOver",
        value: function isMouseOver(t) {
          return Array.prototype.slice.call(t.parentElement.querySelectorAll(":hover")).filter(function () {
            return t[0] == this;
          }).length > 0;
        }
      }, {
        key: "getElementsByAttributeWithinElement",
        value: function getElementsByAttributeWithinElement(t, e, r) {
          return r ? t.querySelectorAll("[" + e + "=\"" + r + "\"]") : t.querySelectorAll("[" + e + "]");
        }
      }, {
        key: "getElementByClassWithinElement",
        value: function getElementByClassWithinElement(t, e) {
          return t.querySelector("." + e);
        }
      }, {
        key: "maxWidthMobileViewports",
        value: function maxWidthMobileViewports() {
          return 940;
        }
      }, {
        key: "createEvent",
        value: function createEvent(t) {
          var e = void 0;return "function" == typeof Event ? e = new Event(t) : (e = document.createEvent("Event"), e.initEvent(t, !0, !0)), e;
        }
      }, {
        key: "isDesktop",
        value: function isDesktop() {
          return Math.max(document.documentElement.clientWidth, window.innerWidth || 0) > this.maxWidthMobileViewports();
        }
      }, {
        key: "isIE11",
        value: function isIE11() {
          return -1 !== navigator.userAgent.indexOf("MSIE") || navigator.appVersion.indexOf("Trident/") > -1;
        }
      }, {
        key: "getKeyCodeOnKeyDownEvent",
        value: function getKeyCodeOnKeyDownEvent(t) {
          var e = void 0;if (null != t) if (void 0 === t.code) switch (t.keyCode) {case 13:
              e = "Enter";break;case 38:
              e = "ArrowUp";break;case 40:
              e = "ArrowDown";break;case 8:
              e = "Backspace";break;case 9:
              e = "Tab";break;case 27:
              e = "Escape";break;case 33:
              e = "PageUp";break;case 34:
              e = "PageDown";break;case 32:
              e = "Space";break;default:
              e = void 0;} else e = t.code;return e;
        }
      }, {
        key: "getKeyboardFocusableElements",
        value: function getKeyboardFocusableElements(t) {
          return [].concat(_toConsumableArray(t.querySelectorAll('a[href], button, input, textarea, iframe, select, details,[tabindex]:not([tabindex="-1"])'))).filter(function (t) {
            return !function (t) {
              return "hidden" === window.getComputedStyle(t).visibility;
            }(t) && !t.hasAttribute("disabled") && !t.getAttribute("aria-hidden");
          });
        }
      }]);

      return _class;
    }();
  }, 102: function _(t, e, r) {
    t.exports = r(103);
  }, 103: function _(t, e, r) {
    "use strict";
    r.r(e), r.d(e, "Filter", function () {
      return s;
    });var n = r(0),
        i = r.n(n);
    var s = function () {
      function s(t) {
        _classCallCheck(this, s);

        this.element = t, this.refineSearchButton = i.a.getElementByAttributeWithinElement(this.element, this.attributes.refineSearch), this.filterContent = i.a.getElementByAttributeWithinElement(this.element, this.attributes.content), this.filterClose = i.a.getElementByAttributeWithinElement(this.element, this.attributes.close), this.scrollPosition = 3, this.addEventHandlers();
      }

      _createClass(s, [{
        key: "addEventHandlers",
        value: function addEventHandlers() {
          var _this = this;

          this.refineSearchButton.addEventListener("click", function () {
            _this.filterContent.classList.add(_this.classes.active), document.body.classList.add(_this.classes.filterActive);
          }), this.filterClose.addEventListener("click", function () {
            _this.filterContent.classList.remove(_this.classes.active), document.body.classList.remove(_this.classes.filterActive);
          }), this.filterContent.addEventListener("scroll", function () {
            _this.checkPosition();
          });
        }
      }, {
        key: "checkPosition",
        value: function checkPosition() {
          var t = this.filterContent.scrollTop;this.filterContent && t > this.scrollPosition && this.filterContent.classList.add(this.classes.scrollActive), (this.filterContent && t < this.scrollPosition || this.filterContent && 0 === t) && this.filterContent.classList.remove(this.classes.scrollActive);
        }
      }, {
        key: "attributes",
        get: function get() {
          return { refineSearch: "data-rs-filter-refine-search", content: "data-rs-filter-content", close: "data-rs-filter-close" };
        }
      }, {
        key: "classes",
        get: function get() {
          return { active: "filter__content--active", scrollActive: "scroll-active", filterActive: "filter-active" };
        }
      }], [{
        key: "getSelector",
        value: function getSelector() {
          return "[data-rs-filter]";
        }
      }]);

      return s;
    }();
  } }));